import { Feedback, FeedbackRequestBody } from 'type/advisor';

export const PRE_IMPRESSION_SKEPTICAL = 'SKEPTICAL';
export const PRE_IMPRESSION_SKEPTICAL_LEGACY = 'SKEPTIKAL';

export const normalizePreImpression = (preImpression?: string | null): string | undefined => {
  if (preImpression === PRE_IMPRESSION_SKEPTICAL_LEGACY) {
    return PRE_IMPRESSION_SKEPTICAL;
  }

  return preImpression ?? undefined;
};

export const normalizeFeedback = (feedback: Feedback): Feedback => {
  if (!feedback?.preImpression) {
    return feedback;
  }

  return {
    ...feedback,
    preImpression: normalizePreImpression(feedback.preImpression),
  };
};

export const normalizeFeedbackRequest = (request: FeedbackRequestBody): FeedbackRequestBody => {
  if (request.preImpression === undefined) {
    return request;
  }

  return {
    ...request,
    preImpression: normalizePreImpression(request.preImpression),
  };
};
